import React, { Component } from "react";
/* import UserService from "../../services/user.service"   //"../../../services/user.service";
import EventBus from "../../common/EventBus"; */

import dotenv from 'dotenv';
import Helper from '../DevServices/Helper'
import LoaderLine from '../DevServices/LoaderLine'
import { Redirect } from 'react-router-dom';
import { connect } from "react-redux";
import { compose } from "redux";
import { 
  update_selected_dev,

  t_api_req_get_device_skeleton_by_dev_id_and_user_id,

  t_get_mobile_devlist_skeleton_by_desk_id_and_user_id,
  t_collect_sensorsdata_by_devs_skeleton_mobile,
  t_update_request_graph_rx_data_mobile,
  t_update_request_graph_rx_data_mobile_pattern_mode,
  t_get_dev_color_code_by_devs_skeleton_mobile,

  t_activator_actions_fromForm,

  //t_get_devinfo_by_desk_id_and_user_id,
  //t_get_sensorlist_by_dev_id_and_user_id,
  t_decode_selected_devID_softly_data,
  t_delete_action_by_id,
} from "../../reducers/dev";
import { Card, Button, Row, Col, Accordion } from 'react-bootstrap';

import SDM_02_actions from "./SDM_02_actions"
import SDM_03_action_list from "./SDM_03_action_list"
import SDM_03_state_list from "./SDM_03_state_list"
import SDM_03_event_list from "./SDM_03_event_list"
import SDM_03_log_list from "./SDM_03_log_list"

//import SDM_81_IconsHelper from "./SDM_81_IconsHelper"


dotenv.config();

class PageSelectedDevMobile extends Component {
/*   constructor(props) {
    super(props);
    //this.handlelocationId = this.handlelocationId.bind(this);
    //this.onChangelocationId= this.onChangelocationId.bind(this);

    this.state = {
      //locationId: 0,
      isShowReady: false,
      //loading: false,
    };
  } */


  componentWillUnmount(){
    clearInterval(this.interval);

    //return this.props.update_selected_dev_id(0)
  }
  
  componentDidMount(){
    const rx_dev_id = this.props.match.params.dev_id
    //console.log(rx_dev_id)
    this.props.update_selected_dev('id', rx_dev_id)
    this.props.t_api_req_get_device_skeleton_by_dev_id_and_user_id()
    
    //-- For display State List, Event List, LOg List
    this.props.t_decode_selected_devID_softly_data(rx_dev_id) //--add refresh data
    //this.props.t_get_devinfo_by_desk_id_and_user_id()
    //this.props.t_get_sensorlist_by_dev_id_and_user_id()
        // Use setState to update the state

    //console.log('this.state: ', this.state)
    this.interval = setInterval(() => {
      this.props.t_collect_sensorsdata_by_devs_skeleton_mobile() //-- refresh data
      this.props.t_decode_selected_devID_softly_data(rx_dev_id)
      this.props.t_get_dev_color_code_by_devs_skeleton_mobile()
      console.log('PageSelectedDesk. Refresh data timer. 2min')
    }, 10*1000);  //2min
  }


  render() {
    if (!this.props.user){
      window.location.href = process.env.REACT_APP_HOST+"/login";
      return null; // Return null to avoid rendering anything else
    } 

    //console.log(this.props.dev?.selected_desk_skeleton_mobile[0]?.dev_id)
    
    const devData = this.props.dev.selected_desk_skeleton_mobile[0]
    const isReadyShow = devData ? true : false

    const icons = {
      id: "🆔",       // ID button
      device: "📱",   // mobile phone
      code: "⌨️",     // keyboard
      value: "🔢",    // numbers
      description: "📝", // memo
      created: "🕒",   // clock
      tool: "🔧",
      Graphic: "📊",
      updated: "📅",
    };

    return (

    <div className="">

{/*     <SDM_02_actions />
    <SDM_02_actions1 /> */}

{  isReadyShow &&  //Test full loaded data

 <div className="border ">
      <div className="card-body">
  <h5 className="card-title d-flex align-items-center gap-2 mb-0 text-info">
  <div className={`${devData.dev_color_code?.length && 'psdm__color-circle--' + devData.dev_color_code[0].max_color_code}`}></div>
  <span>#{devData.dev_id}</span>
  <span>{devData.dev_name}</span>
</h5>
    <h6 className="card-subtitle mb-2 mt-2 text-body-secondary">{str_sensor_data(devData.dev_sensors_data)}</h6>

    
   {this.props.dev.selected_desk_skeleton_mobile[0]?.dev_actions &&
    <SDM_02_actions
    dev_actions = {this.props.dev.selected_desk_skeleton_mobile[0].dev_actions}
    t_activator_actions_fromForm = {this.props.t_activator_actions_fromForm}
    />}


    
    <Accordion defaultActiveKey={['0']} alwaysOpen>
      {this.props.dev.selectedDev?.rx_action_list && 
      <Accordion.Item eventKey="1">
        <Accordion.Header> 
        Action List
        </Accordion.Header>
        <Accordion.Body>
          <SDM_03_action_list 
            rx_action_list = {this.props.dev.selectedDev.rx_action_list}
            t_delete_action_by_id={this.props.t_delete_action_by_id}
            icons = {icons}
          />
        </Accordion.Body>
      </Accordion.Item>}

      <Accordion.Item eventKey="2">
        <Accordion.Header> 
          State status
        </Accordion.Header>
        <Accordion.Body>
          <SDM_03_state_list 
            rx_state_list = {this.props.dev.selectedDev.rx_state_list}
            icons = {icons}
          />
        </Accordion.Body>
      </Accordion.Item>  

      <Accordion.Item eventKey="3">
        <Accordion.Header> 
          Event List
        </Accordion.Header>
        <Accordion.Body>
          <SDM_03_event_list 
            rx_event_list = {this.props.dev.selectedDev.rx_event_list}
            icons = {icons}
          />
        </Accordion.Body>
      </Accordion.Item>  

      <Accordion.Item eventKey="4">
        <Accordion.Header> 
          Log List
        </Accordion.Header>
        <Accordion.Body>
          <SDM_03_log_list 
            rx_log_list = {this.props.dev.selectedDev.rx_log_list}
            icons = {icons}
          />
        </Accordion.Body>
      </Accordion.Item> 

      </Accordion>
      
  </div>

      </div>
      
      }
{/*        <button
        onClick={()=>{
          //console.log("Hello Test")
          this.props.t_get_sensor_data_daily_by_selectedDevId_sensorId();
          //Get hourly data
          //this.props.thunkTest(this.props.user.accessToken)
        }}
      >Click Me2</button> 
      <TemperatureHumidityChart /> */}


      {/* <LoaderLine /> */}
{/*       <SelectedDeviceInfo
      selectedDev = {this.props.dev.selectedDev}
      isLoading = {this.props.dev.isLoading}
      /> */}

{/*       <DevList data = {this.props.dev.selectedDev.v2_devinfo}
      isLoading = {this.props.dev.isLoading}
      />

      <ActionComposer
      //json_actions = {this.props.dev.selectedDev}
      selectedDev = {this.props.dev.selectedDev}
      t_activator_actions_fromForm = {this.props.t_activator_actions_fromForm}
      />
      <ActionList
        rx_action_list = {this.props.dev.selectedDev.rx_action_list}
        t_delete_action_by_id={this.props.t_delete_action_by_id}
      />
      <StateList 
        rx_state_list = {this.props.dev.selectedDev.rx_state_list}
      />  

      <EventList
        rx_event_list = {this.props.dev.selectedDev.rx_event_list}
      />
      <LogList
        rx_log_list = {this.props.dev.selectedDev.rx_log_list}
      />  */}
      
      <Helper props={this.props} />
      
    </div>
    );
  }
}

function mapStateToProps(state) {
  //console.log(state)
  const { user, test } = state.auth;

  return {
    user,
    test,
    dev: state.dev,
/*    location: state.location */
  };
}

  const mapDispatchToProps = { 
    update_selected_dev, 

    t_api_req_get_device_skeleton_by_dev_id_and_user_id,

    t_get_mobile_devlist_skeleton_by_desk_id_and_user_id,
    t_collect_sensorsdata_by_devs_skeleton_mobile,
    t_update_request_graph_rx_data_mobile,
    t_update_request_graph_rx_data_mobile_pattern_mode,

    t_activator_actions_fromForm,

    //t_get_devinfo_by_desk_id_and_user_id,
    //t_get_sensorlist_by_dev_id_and_user_id,
    t_decode_selected_devID_softly_data,
    t_delete_action_by_id,
    t_get_dev_color_code_by_devs_skeleton_mobile,

  }



export default compose(
  connect(mapStateToProps, mapDispatchToProps)
  //withAuthRedirect
)(PageSelectedDevMobile);

const str_sensor_data = (dev_sensors_data) => {
  if (!dev_sensors_data?.length) return <></>

  const out = dev_sensors_data?.map((v, i) => {
    return (
      <span key={i}>
        #{v.sensor_id}{" ("}
        {v.last_value?.map((av, ai) => {
          //console.log(av.s_value);
          return (
            <span key={ai}>
              {av.s_value !== null 
                ? `${av.card_prefix}${av.s_value}${av.card_suffix}` 
                : "-"}
              {ai < v.last_value.length - 1 && ", "} {/* Add a comma if it's not the last item */}
            </span>
          );
        })}
        {") "}
      </span>
    );
  });
  return <>Sensors: {out}</>
};

const xd_str_sensor_data1 = (dev_sensors_data) => {
  const a = []
  
  const sensors_data = dev_sensors_data?.map((v, i) => {
    return (
      <span key={i}>
        #{v.sensor_id}{" ("}
        {v.last_value?.map((av, ai) => {
          
          //console.log(av.s_value)
          if (av.s_value !== null) return (
             <span key={ai}>{av.card_prefix}{av.s_value}{av.card_suffix}</span> 
          ) 
          return <span key={ai}>-</span> 
        })}
        {") "}
      </span>
    );
  });
  return sensors_data
};

const TestElement = () => {
  const commands = [
    { id: 1, text: 'Restart Device', options: null },
    { id: 2, text: 'Set Brightness', options: [10, 20, 30, 40, 50] },
    { id: 3, text: 'Set Volume', options: [1, 2, 3, 4, 5] },
    { id: 4, text: 'Enable WiFi', options: null },
    { id: 5, text: 'Change Mode', options: ['Eco', 'Performance', 'Balanced'] },
    { id: 6, text: 'Shutdown', options: null },
    { id: 7, text: 'Select Profile', options: ['Admin', 'User', 'Guest'] },
    { id: 8, text: 'Update Firmware', options: null },
    { id: 9, text: 'Set Timeout', options: [5, 10, 15, 30] },
    { id: 10, text: 'Restart Network', options: null }
  ];
  return (<>
    <style>
      {`
        @media screen and (max-width: 768px) {
          table.table {
            display: none; /* hide table on mobile */
          }

          .mobile-card {
            background-color: white;
            margin-bottom: 1rem;
            padding: 1rem;
            border-radius: 6px;
            box-shadow: 0 2px 5px rgba(0,0,0,0.1);
          }

          .mobile-card p {
            margin: 0.5rem 0;
          }

          .mobile-label {
            font-weight: bold;
          }
        }
      `}
    </style>
    <div className="d-md-none">

    <div className="mobile-card">
      <p><span className="mobile-label">ID:</span> 12</p>
      <p><span className="mobile-label">Dev ID:</span>12</p>
      <p><span className="mobile-label">Code:</span> er</p>
      <p><span className="mobile-label">Integer Value:</span>23</p>
      <p><span className="mobile-label">Float Value:</span> 223.7</p>
      <p><span className="mobile-label">String Value:</span> rr</p>
      <p><span className="mobile-label">Result:</span> ttt</p>
      <button >Delete</button>
    </div>

</div>

    </>
  );
};
